
export const SALAT_PDF_URL = process.env.REACT_APP_SALAT_PDF_URL || 'https://rukousajat.fi/public/salaat.pdf'
export const APP_DEEPLINK_URL = process.env.REACT_APP_DEEPLINK_URL || 'https://rukousajat.fi/deeplink.php'
export const HIJRI_URL = process.env.REACT_APP_HIJRI_URL || 'https://rukousajat.fi/api/hijri.php'
